import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import Spin from 'antd/lib/spin';
import 'antd/lib/spin/style/css'
import { graphql } from '@apollo/react-hoc';
import gql from "graphql-tag";

import NoticeBox from '../components/notice_box'
import TextField from '../components/fields/text_field'

import './forgot_password_page.scss'

class ForgotPasswordPage extends React.Component
  constructor: (props) ->
    super(props)
    @state = { 
      error: null,
      sendingRequest: false 
    }

  recoverPassword: (e) =>
    e.preventDefault()
    @setState sendingRequest: true, error: null

    # Accessing the parent frame when we're not allowed will throw an "Access Denied"
    # exception. The long-term solution is to use HTML5 messaging to access
    # these preferences instead of trying to access them directly.
    # ---
    # Below lines can be removed once everybody is on the new CMS plugin
    try
      if window.frameElement
        reset_pw_url = $(window.frameElement).data('ma-reset-password-url')
    catch
      null

    if !reset_pw_url
      reset_pw_url = JSON.parse(document.body.dataset.urls).reset_password

    formData = $(@refs.form).serialize()
    formData += "&reset_password_url=#{reset_pw_url}" if reset_pw_url

    $.post window.urls.profiles.recoverPassword, formData, (data) =>
      if data.error
        @setState error: data.error, sendingRequest: false
      else
        @setState error: null, success: data.success, sendingRequest: false

  renderBack: ->
    return null unless @props.options.showBack
    <button className="back ma-button btn btn-link" ref="button"
            onClick={ (e) => e.preventDefault(); window.history.back() }>
      {@props.content.page.backLabel}
    </button>

  renderForm: ->
    if @state.sendingRequest
      buttonLabel = <Spin size="small"/>
    else
      buttonLabel = @props.content.page.buttonLabel
  
    <div>
      <div className="login-field">
        <label>{@props.content.page.emailLabel}</label>
        <TextField field="username"/>
      </div>

      <button className="ma-button btn hudson-button" ref="button">
        {buttonLabel}
      </button>
    </div>

  render: ->
    style = ".ant-spin-dot i { \
               background-color: #{@props.colors?.buttonColor} \
             } \
    "
    if @state.error 
      noticeBox = <NoticeBox type="error" 
                    content={{ message: @state.error }}/> 
    else if @state.success
      noticeBox = <NoticeBox type="notice" 
                    content={{ message: @state.success }}/> 
  
    <div className="forgot-password-page">
      <style>{style}</style>

      <div>
        <h4 dangerouslySetInnerHTML={{__html: @props.content.page.title}}/>

        {
          if @props.content.page.content
            <div className="content"
                dangerouslySetInnerHTML={{__html: @props.content.page.content}}/>
        }

        {noticeBox}

        <form role="form" ref="form" onSubmit={@recoverPassword}>
          { 
            unless @state.success
              @renderForm()
          }

          {@renderBack()}          
        </form>
      </div>
    </div>

ForgotPasswordPage.propTypes = {
  content: PropTypes.object,
  options: PropTypes.object
}

# --- Connect to Redux
mapStateToProps = (state) ->
  {
    content: state.content, 
    options: state.configuration
  }

mapDispatchToProps = (dispatch) -> bindActionCreators({
}, dispatch)

# --- Apollo/GraphQL
apolloComponent = graphql(gql("
  query forgotPasswordPageQuery {
    colors {
      buttonColor
      id
      }
  }"),  
  {
    props: (apollo) => 
      return {
        colors: apollo.data.colors || {}
      }
  }
)(ForgotPasswordPage)

export default connect(mapStateToProps, mapDispatchToProps)(apolloComponent)
